$.fn.setupToolbar = function (o) {
    /// <summary>Sets up up a cafm toolbar</summary>
    /// <param name="o" type="Object">The toolbar options</param>
    /// <returns type="JQuery">Returns JQuery element</returns>
    
    this.each(function (i, el) {

        el = $(el);

        if (o) {

            el.data(o);
        }

        var h = el.data('handler');

        if (h) {
            var btns = $('.btn', el), refName = h;
            h = cafm.util.getReference(h);
            if (h) {
                var vm = o ? o.viewModel : null;
                if (vm) {
                    btns.each(function (i, b) {
                        b = $(b);
                        var tbKey = b.data('key').toLowerCase();
                        var f = h[tbKey];
                        if (f) {

                            b.attr('data-bind', 'click: {0}'.format(tbKey));

                            if (!vm[tbKey]) {

                                if (isFunc(vm.set)) {

                                    vm.set(tbKey, f);
                                }
                                else {

                                    vm[tbKey] = f;
                                }
                            }
                        }
                    });
                }
                else {

                    btns.removeAttr('data-bind');
                    kendo.unbind(btns); // prevent hassle of bound buttons that don't have the function on the VM

                    btns.off('click.tb').on('click.tb', function (e) {
                        let b = $(e.currentTarget), tbKey = b.data('key').toLowerCase(), url = b.data('url');
                        if (isFunc(h[tbKey])) {
                            setTimeout(function () {
                                h[tbKey](e, h);
                            }, 100);
                        }
                        if (url) {
                            cafm.url.set(url);
                            return;
                        }
                        
                    });
                }
                if (h.hover) {
                    btns.hover(function (e) {
                        h.hover(true, e);
                    }, function (e) {
                        h.hover(false, e);
                    });
                }
            }
            btns.data('toolbar', el);
        }
    });
    return this;
}

cafm.toolbar = {

    standardActionToolbar: {

        submit: function (e) {
             
            var actionFormPlc = cafm.views.getActionForm(),
                actionForm = actionFormPlc.find('.actionForm:first'),
                handler = actionForm.data('eventhandler'),
                submitAction = actionForm.data('submitaction'),
                loaderSelector = actionForm.data('loaderselector'),
                validate, beforeSend, success, conflict;

            if (isStr(handler)) {

                handler = cafm.util.getReference(handler);

                if (!isNullOrUndefined(handler)) {

                    validate = handler.validate;
                    beforeSend = handler.beforeSend;
                    success = handler.success;
                    conflict = handler.conflict;
                }
            }

            cafm.actions.execute({

                url: submitAction,
                values: cafm.views.getActionWindowViewModel(),
                elementId: actionFormPlc.attr('id'),
                loaderSelector: loaderSelector,
                loaderTarget: actionFormPlc[0],
                validate: validate,
                beforeSend: beforeSend,
                offlineActionType: handler && isFunc(handler.offlineActionType) ? handler.offlineActionType() : null,
                statusCodeFuncs: {

                    200: function (r, s, m, a) {

                        if(isFunc(success)){

                            success(r, a);
                        }
                    },
                    204: success,
                    409: function (r, s, m, a) {

                        if (isFunc(conflict)) {

                            conflict(r.responseJSON ? r.responseJSON : r, a);
                        }
                    }
                },
                fallback: handler ? handler.fallback : null
            });
        },
        cancel: function () {
            
            cafm.views.closeActionWindow();
        }
    },
    closeToolbar: {

        close: function (e) {

            var btn = $(e.target);

            if (btn.parents('.k-window:first').length) {
                                
                var win = btn.getParentWindow();

                if (win) {

                    win.close();
                }                
            }
            else if(isMobile && btn.parents('.mobileActionPanel:first').length) {

                cafm.views.closeActionWindow();
            }
        }
    },
    helpers: {
        
        getActionToolbarButton: function (key) {
            
            return $('.{0}'.format(cafm.res.consts.CssClass_WindowButtons)).find('[data-key="{0}"]'.format(key));
        },
        hideActionToolbarButton: function (key) {
            
            cafm.toolbar.helpers.getActionToolbarButton(key).hide();
        },
        showActionToolbarButton: function (key) {
            
            cafm.toolbar.helpers.getActionToolbarButton(key).show();
        },
        ensureToolbarDisplay: function () {

            var ab = $(".action-buttons");
            if (ab.length) {
                $("#sub-header-toolbar").show();
                cafm.util.callFunction(cafm.toolbar.ensureButtonGroupFits, ab);

                if (isMobile) {

                    $(document).off("scroll.cafmtb").on("scroll.cafmtb", function () {

                        cafm.util.callFunctionAsync({
                            func: function () {

                                if (!$("#sub-header").isOnScreen()) {
                                    $("#sub-header-toolbar").addClass("fixed-sub-header-toolbar");
                                }
                                else {
                                    $("#sub-header-toolbar").removeClass("fixed-sub-header-toolbar");
                                }
                            }, timeout: 100, key: 'cafmtbscroll'
                        })
                    })
                }
            }
        }
    }
}